window.theme = window.theme || {};

theme.recentSearches = (function() {
  const STORAGE_KEY = 'recentSearches';
  const MAX_SEARCHES = 8;

  function getSearches() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return [];
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setSearches(searches) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
    } catch (e) {}
  }

  function addSearch(term) {
    const trimmed = String(term || '').trim();
    if (!trimmed) return;

    const normalized = trimmed.toLowerCase();
    let searches = getSearches().filter((t) => String(t).toLowerCase() !== normalized);
    searches.unshift(normalized);
    searches = searches.slice(0, MAX_SEARCHES);
    setSearches(searches);
  }

  function removeSearch(term) {
    const normalized = String(term || '').trim().toLowerCase();
    setSearches(getSearches().filter((t) => String(t).toLowerCase() !== normalized));
  }

  function hasSearches() {
    return getSearches().length > 0;
  }

  function getElements() {
    const block = document.querySelector('[data-recent-searches]');
    if (!block) return null;

    const dragScroll = block.querySelector('theme-drag-scroll');
    const list = dragScroll?.querySelector(':scope > .theme-drag-scroll__list') || null;
    if (!list) return null;

    return { block, dragScroll, list };
  }

  function buildChip(term, els) {
    const template = document.getElementById('predictive-search-recent-chip-template');
    const node = template?.content.firstElementChild?.cloneNode(true);
    if (!node) return null;

    const link = node.querySelector('[data-recent-chip-link]');
    if (link) {
      link.textContent = term;
      link.href = `${theme.routes.searchUrl}?q=${encodeURIComponent(term)}`;
    }

    const removeBtn = node.querySelector('[data-recent-chip-remove]');
    if (removeBtn) {
      const label = (theme.locales?.search?.removeRecentSearch || term).replace('[terms]', term);
      removeBtn.setAttribute('aria-label', label);
      removeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        removeSearch(term);
        node.remove();
        els.dragScroll?.reanchor?.();
        if (!hasSearches()) hide();
      });
    }

    return node;
  }

  function render() {
    const els = getElements();
    if (!els) return;

    if (!hasSearches()) {
      els.block.hidden = true;
      return;
    }

    els.list.innerHTML = '';
    const frag = document.createDocumentFragment();
    getSearches().forEach((term) => {
      const chip = buildChip(term, els);
      if (chip) frag.appendChild(chip);
    });
    els.list.appendChild(frag);

    els.block.hidden = false;
    els.dragScroll?.reanchor?.();
  }

  function hide() {
    const block = document.querySelector('[data-recent-searches]');
    if (block) block.hidden = true;
  }

  return {
    getSearches,
    addSearch,
    removeSearch,
    hasSearches,
    render,
    hide,
  };
})();

if (window.theme?.pubsub) {
  theme.pubsub.subscribe(theme.pubsub.events.SEARCH_QUERY, ({ query }) => {
    theme.recentSearches.addSearch(query);
  });
}
